import { render, staticRenderFns } from "./ShelfNo.vue?vue&type=template&id=5d9a6b70&"
import script from "./ShelfNo.vue?vue&type=script&lang=ts&"
export * from "./ShelfNo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports